import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const InlineLinkWrapper = styled.button<{ variant: 'default' | 'danger' }>`
  ${Reset('button')}
  position: relative;
  font-weight: 500;
  border-bottom: 1px solid currentColor;
  display: inline-block;
  font-size: 1.2rem;

  ${props =>
    props.variant === 'danger' &&
    !props.theme.contrastMode &&
    css`
      color: ${props.theme.color.red};
    `}

  &:hover {
    border-bottom-color: transparent;
  }
`
